import type { UnitType } from "@/features/quotation/types";

export const QUOTATION_UNIT_OPTIONS: UnitType[] = [
  "kg",
  "cx_kg",
  "cx_un",
  "bdj",
  "un",
  "sc_kg",
];

export const QUOTATION_UNIT_LABELS: Record<UnitType, string> = {
  kg: "Kg",
  cx_kg: "Cx/Kg",
  cx_un: "Cx/Un",
  bdj: "Bandeja",
  un: "Un",
  sc_kg: "Sc/Kg",
};

export const PRICE_PER_UNIT_SUFFIX: Record<UnitType, string> = {
  kg: "Kg",
  cx_kg: "Kg",
  cx_un: "Un",
  bdj: "Bdj",
  un: "Un",
  sc_kg: "Kg",
};

export function isDirectKgUnit(unitType: UnitType) {
  return unitType === "kg";
}

export function usesKgPerBox(unitType: UnitType) {
  return unitType === "cx_kg" || unitType === "sc_kg";
}

export function usesUnitsPerBox(unitType: UnitType) {
  return unitType === "cx_un";
}

export function getQuotationPriceInputLabel(unitType: UnitType) {
  switch (unitType) {
    case "kg":
      return "Preço por kg (R$)";
    case "un":
      return "Preço por unidade (R$)";
    case "bdj":
      return "Preço por bandeja (R$)";
    case "sc_kg":
      return "Preço por saco (R$)";
    default:
      return "Preço por caixa (R$)";
  }
}

export function getQuotationBasePriceSuffix(unitType: UnitType) {
  switch (unitType) {
    case "kg":
      return "kg";
    case "un":
      return "un";
    case "bdj":
      return "bdj";
    case "sc_kg":
      return "sc";
    default:
      return "cx";
  }
}

export function getQuotationBasePriceValue(item: {
  unit_type: UnitType;
  price_per_box?: number;
  price_per_kg?: number;
}) {
  return isDirectKgUnit(item.unit_type)
    ? (item.price_per_kg ?? 0)
    : (item.price_per_box ?? 0);
}

export function buildUnitPricePreview(params: {
  unitType: UnitType;
  pricePerBox: number | null | undefined;
  pricePerKg: number | null | undefined;
  kgPerBox: number | null | undefined;
  unitsPerBox: number | null | undefined;
}) {
  const { unitType, pricePerBox, pricePerKg, kgPerBox, unitsPerBox } = params;

  if (isDirectKgUnit(unitType)) {
    if (pricePerKg == null || pricePerKg <= 0) return null;
    return { label: PRICE_PER_UNIT_SUFFIX[unitType], value: pricePerKg };
  }

  if (pricePerBox == null || pricePerBox <= 0) return null;
  if (unitType === "un" || unitType === "bdj") {
    return { label: PRICE_PER_UNIT_SUFFIX[unitType], value: pricePerBox };
  }
  if (usesKgPerBox(unitType)) {
    if (kgPerBox == null || kgPerBox <= 0) return null;
    return {
      label: PRICE_PER_UNIT_SUFFIX[unitType],
      value: pricePerBox / kgPerBox,
    };
  }
  if (usesUnitsPerBox(unitType)) {
    if (unitsPerBox == null || unitsPerBox <= 0) return null;
    return {
      label: PRICE_PER_UNIT_SUFFIX[unitType],
      value: pricePerBox / unitsPerBox,
    };
  }
  return null;
}
